import { StaticTextLabel } from "./StaticTextLabel.js";
import { store } from "../core/store.js";

class FigureTextLabel extends StaticTextLabel {
  constructor(options) {
    super(options);
    this.type = "STATIC_TEXT_LABEL";
    this.parentImageId = options.parentImageId;
    this.textPosition = options.textPosition || "below";
  }

  getStyle() {
    if (this.canvasTexture && this.canvasTexture.style) {
      return JSON.parse(JSON.stringify(this.canvasTexture.style));
    }

    return {
      backgroundColor: "rgba(33, 33, 33, 0.8)",
      color: "#FFFFFF",
      padding: 50,
      paddingHeight: 20,
      borderRadius: 5,
      font: "150px Arial",
    };
  }

  setStyle(style) {
    super.setStyle(style);
    store.requestRender();
  }

  serialize() {
    const data = super.serialize();
    data.type = "STATIC_TEXT_LABEL";
    data.parentImageId = this.parentImageId;
    data.textPosition = this.textPosition;
    return data;
  }
}

export { FigureTextLabel };
